import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-news-laters',
  templateUrl: './news-laters.component.html',
  styleUrls: ['./news-laters.component.css']
})
export class NewsLatersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
